<template>
  <div class="app-inner">
    <el-form :inline="true">
      <el-form-item label="考勤时段">
       <el-date-picker
        v-model="time"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"/>
      </el-form-item>
      <el-form-item>
        <!-- <el-button @click="dk">打卡</el-button> -->
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="warning" @click="add" :disabled="abnormalList.length === 0">提交外出及刷卡异常</el-button>
        <el-button type="warning" @click="showRecord">异常申请记录</el-button>
      </el-form-item>
    </el-form>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange"
    :selectable="selectable"
    @selection-change="handleSelection">
      <template #selection/>
    </table-list>
    <!-- 异常申请 -->
    <abnormal-application ref='AbnormalApplication' @query="query"/>
    <application-record ref='ApplicationRecord' @showDetails="showDetails" @update="update"/>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import AbnormalApplication from './abnormalApplication.vue'
import ApplicationRecord from './applicationRecord.vue'
import { query, getApplyDetail } from '@/api/compAttendance.js'
import { AttendanceStatus } from '@/utils/constants'
export default {
  data () {
    return {
      time: [],
      page: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      columnDefs: [
        { label: '姓名', prop: 'chineseName' },
        { label: '上班时间', prop: 'arrivalTime' },
        { label: '下班时间', prop: 'leaveTime' },
        {
          label: '打卡状态',
          prop: 'status',
          formatter: (row) => {
            let status = AttendanceStatus.find(item => item.value === row.status)
            return status?.label || ''
          }
        },
        { label: '打卡日期', prop: 'checkDate' },
      ],
      tableData: [],
      abnormalList: []
    }
  },
  components: {
    TableList,
    AbnormalApplication,
    ApplicationRecord
  },
  methods: {
    query () {
      this.page = 1
      this.getData()
    },
    getData () {
      console.log(this.time)
      this.loading = true
      query({
        pageNum: this.page,
        pageSize: this.pageSize,
        startTime: this.time?.[0] || '',
        endTime: this.time?.[1] || ''
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        console.log(result.records, 'result.records')
        this.tableData = result.records
        this.totalCount = result.total
        this.$refs.ApplicationRecord.getData()
      })
    },
    selectable (item) {
      const normalType = [ -1, 0, 4 ]
      return normalType.indexOf(item.status) === -1 && !item.inApplyFlag
    },
    handleSelection (value) {
      this.abnormalList = value
    },
    add () {
      this.$refs.AbnormalApplication.actionType = 'new'
      this.$refs.AbnormalApplication.showDialog('new', this.abnormalList, 'queryMine')
    },
    showDetails (id) {
      console.log(id)
      this.$refs.AbnormalApplication.showDialog('details', id)
    },
    async update (id) {
      const { code, result: { attendanceGetDetailRespList } } = await getApplyDetail({
        id
      })
      this.loading = false
      if (code !== 0) return
      this.$refs.AbnormalApplication.actionType = 'update'
      this.$refs.AbnormalApplication.showDialog('new', attendanceGetDetailRespList, 'queryMine')
      this.$refs.AbnormalApplication.getDetails(id)
    },
    showRecord () {
      this.$refs.ApplicationRecord.showDialog()
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    // dk () {
    //   add().then(res => {
    //     console.log(res)
    //   })
    // }
  },
  mounted () {
    this.query()
  }
}
</script>